module.exports = __webpack_public_path__ + "static/media/VAS_FEEDBACK_5.53466e07.svg";